import Vue from 'vue';
import Router from 'vue-router';
import Multiguard from 'vue-router-multiguard';
import jwtDecode from 'jwt-decode';

import OperatorBaseDetails from './views/Operator/BaseDetails.vue'
import OperatorInvoiceSettings from './views/Operator/InvoiceSettings.vue';

// import Calendar from './views/Calendar.vue';
import Home from './views/Home.vue'
import PaymentDetails from './views/Operator/PaymentDetails.vue'
import SmsDetails from './views/Operator/SmsDetails.vue'
import List from './views/Operator/List.vue'
// import GeneralDetails from './views/Facility/GeneralDetails.vue'
// import Extra from './views/Facility/Extra.vue'
// import PriceOverview from './views/Facility/PriceOverview.vue'
// import UpdateBookingPrices from './views/Facility/UpdateBookingPrices.vue'

// import ListProducts from './views/Settings/Products/List.vue'
// import Product from './views/Settings/Products/Product.vue'
//
// import CoursesList from './views/Settings/Courses/List.vue'
// import CoursesData from './views/Settings/Courses/Details.vue'
// import DateSettings from './views/Settings/Courses/DateSettings.vue'
// import PricesList from './views/Settings/Courses/Prices/List.vue'
// import PriceData from './views/Settings/Courses/Prices/Price.vue'
// import CourseAppointments from './views/Settings/Courses/Appointments/List.vue'
// import CourseAppointment from './views/Settings/Courses/Appointments/Appointment.vue'
// import CourseCard from './views/Settings/Courses/Card.vue'
// import TrainersList from './views/Settings/Courses/Trainers/List.vue'
// import CreateTrainer from './views/Settings/Courses/Trainers/CreateTrainer.vue'
//
// import ExternalVenues from './views/Settings/Courses/ExternalVenues/List.vue'
// import CreateExternalVenue from './views/Settings/Courses/ExternalVenues/CreateExternalVenue.vue'
//
// import SharedBookingWeek from './views/Settings/SharedBookings/Week.vue'
// import PriceSetups from './views/Settings/SharedBookings/PriceSetups.vue'
// import PriceSetupDetails from './views/Settings/SharedBookings/PriceSetupDetails.vue'
// import PriceSetupPreice from './views/Settings/SharedBookings/PriceSetupPreice'
// import CategoriesList from './views/Settings/Courses/Categories/List.vue'
// import CategoriesCreate from './views/Settings/Courses/Categories/CreateCategory.vue'
//
// import CourseSettings from './views/Settings/Courses/Settings.vue'
// import GroupsList from './views/Settings/Groups/List.vue'
// import GroupShow from './views/Settings/Groups/Show.vue'
// import OnlineGeneral from './views/Settings/Online/General.vue'
// import OnlineVenues from './views/Settings/Online/Venues.vue'
// import OnlineSharedBookings from './views/Settings/Online/SharedBookings.vue'
// import OnlineCourses from './views/Settings/Online/Courses.vue'
// import OnlineRooms from './views/Settings/Online/Rooms.vue'
// import OnlineAnnouncements from './views/Settings/Online/Announcements.vue'
// import OnlineInfoscreens from './views/Settings/Online/Infoscreens.vue'
// import OnlineVenueClusters from './views/Settings/Online/VenueClusters.vue'
// import OnlineCreateVenueCluster from './views/Settings/Online/CreateVenueCluster.vue'
// import SettingsVenuesData from './views/Settings/Venues/Data.vue'
// import SettingsVenuesProperties from './views/Settings/Venues/Properties.vue'
// import SettingsVenuesImages from './views/Settings/Venues/Images.vue'
// import SettingsVenuesPrices from './views/Settings/Venues/Prices.vue'
// import SettingsVenuesSubscription from './views/Settings/Venues/Subscription.vue'
// import SettingsVenuesTimeframes from './views/Settings/Venues/Timeframes.vue'
// import SettingsVenuesTimeframe from './views/Settings/Venues/Timeframe.vue'
// import SettingsVenuesSettings from './views/Settings/Venues/Settings.vue'
// import SettingsMembersList from './views/Settings/Members/Members.vue'
// import SettingsMembersTypes from './views/Settings/Members/Types.vue'
// import SettingsMembersNewtype from './views/Settings/Members/Newtype.vue'
//
// import Staffmembers from './views/Settings/Staff/Staffmembers.vue'
// import StaffmemberNew from './views/Settings/Staff/StaffmemberNew.vue'
// import Staffmessage from './views/Settings/Staff/Staffmessage.vue'
// import RoomCategoriesList from './views/Settings/Rooms/Categories/Categories.vue'
// import RoomCategoriesNew from './views/Settings/Rooms/Categories/New.vue'
// import VenueBookings from './views/Venues/VenueBookings.vue'
// import VenueBookingDetails from './views/Venues/VenueBookingDetails.vue'
//
// import VenuesDaysSchedulePDF from './views/Venues/VenuesDaysSchedulePDF.vue'
// import VenuesScheduler from './views/Venues/VenuessScheduler.vue'

Vue.use(Router)

const storeTokenFromUrl = (to, from, next) => {
    if (typeof to.query.token !== 'undefined') {
        localStorage.authenticationToken = to.query.token;

        var jwtDecode = require('jwt-decode');
        let decodedToken = jwtDecode(to.query.token);

        var resources = Object.keys(decodedToken.permissions);
        localStorage.partnerCode = resources[0];
    }
    next();
};

const loggedInGuard = (to, from, next) => {
    if (localStorage.getItem('authenticationToken') === null) {
        window.location.replace(window.loginServiceUrl);
    }
    next();
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/operators/:id',
            name: 'operatorBaseData',
            component: OperatorBaseDetails,
            beforeEnter: Multiguard([storeTokenFromUrl, loggedInGuard])
        },
        {
            path: '/operators/:id/invoice-settings',
            name: 'operatorInvoiceSettings',
            component: OperatorInvoiceSettings,
            beforeEnter: Multiguard([storeTokenFromUrl, loggedInGuard])
        },
        {
            path: '/operator/payment-details',
            name: 'operator-payment-details',
            component: PaymentDetails
        },
        {
            path: '/operator/sms-details',
            name: 'operator-sms-details',
            component: SmsDetails
        },
        {
            path: '/operator/list',
            name: 'operator-list',
            component: List
        },
    // {
    //   path: '/facility/generaldetails',
    //   name: 'facility-generaldetails',
    //   component: GeneralDetails
    // },
    // {
    //   path: '/facility/extra',
    //   name: 'facility-extra',
    //   component: Extra
    // },
    // {
    //   path: '/facility/priceoverview',
    //   name: 'facility-priceoverview',
    //   component: PriceOverview
    // },
    // {
    //   path: '/facility/updatebookingprices',
    //   name: 'facility-updatebookingprices',
    //   component: UpdateBookingPrices
    // },
    // {
    //   path: '/settings/products/list',
    //   name: 'settings-products-list',
    //   component: ListProducts
    // },
    // {
    //   path: '/settings/products/product',
    //   name: 'settings-products-product',
    //   component: Product
    // },
    // {
    //   path: '/settings/courses/list',
    //   name: 'settings-courses-list',
    //   component: CoursesList
    // },
    // {
    //   path: '/settings/courses/data',
    //   name: 'settings-courses-data',
    //   component: CoursesData
    // },
    // {
    //   path: '/settings/courses/datesettings',
    //   name: 'settings-courses-datesettings',
    //   component: DateSettings
    // },
    // {
    //   path: '/settings/courses/prices/list',
    //   name: 'settings-courses-prices-list',
    //   component: PricesList
    // },
    // {
    //   path: '/settings/courses/prices/data',
    //   name: 'settings-courses-prices-data',
    //   component: PriceData
    // },
    // {
    //   path: '/settings/courses/appointments/list',
    //   name: 'settings-courses-appointmentslist',
    //   component: CourseAppointments
    // },
    // {
    //   path: '/settings/courses/appointments/appointment',
    //   name: 'settings-courses-appointments-appointment',
    //   component: CourseAppointment
    // },
    // {
    //   path: '/settings/courses/card',
    //   name: 'settings-courses-card',
    //   component: CourseCard
    // },
    // {
    //   path: '/settings/courses/trainers/list',
    //   name: 'settings-courses-trainers-list',
    //   component: TrainersList
    // },
    // {
    //   path: '/settings/courses/trainers/create',
    //   name: 'settings-courses-trainers-create',
    //   component: CreateTrainer
    // },
    // {
    //   path: '/settings/courses/externalvenues/list',
    //   name: 'settings-courses-externalvenues-list',
    //   component: ExternalVenues
    // },
    // {
    //   path: '/settings/courses/externalvenues/create',
    //   name: 'settings-courses-externalvenues-create',
    //   component: CreateExternalVenue
    // },
    // {
    //   path: '/settings/courses/categories/list',
    //   name: 'settings-courses-externalvenues-list',
    //   component: CategoriesList
    // },
    // {
    //   path: '/settings/courses/categories/create',
    //   name: 'settings-courses-externalvenues-create',
    //   component: CategoriesCreate
    // },
    // {
    //   path: '/settings/courses/settings',
    //   name: 'settings-courses-settings',
    //   component: CourseSettings,
    // },
    // {
    //   path: '/settings/sharedbookings/week',
    //   name: 'settings-sharedbookings-week',
    //   component: SharedBookingWeek
    // },
    // {
    //   path: '/settings/sharedbookings/pricesetups',
    //   name: 'settings-sharedbookings-pricesetups',
    //   component: PriceSetups
    // },
    // {
    //   path: '/settings/sharedbookings/pricesetups/details',
    //   name: 'settings-sharedbookings-pricesetups-details',
    //   component: PriceSetupDetails
    // },
    // {
    //   path: '/settings/sharedbookings/pricesetups/price',
    //   name: 'settings-sharedbookings-pricesetups-price',
    //   component: PriceSetupPreice
    // },
    // {
    //   path: '/settings/group/list',
    //   name: 'settings-group-list',
    //   component: GroupsList
    // },
    // {
    //   path: '/settings/group/show',
    //   name: 'settings-group-show',
    //   component: GroupShow
    // },
    // {
    //   path: '/settings/online/general',
    //   name: 'settings-online-general',
    //   component: OnlineGeneral
    // },
    // {
    //   path: '/settings/online/venues',
    //   name: 'settings-online-venues',
    //   component: OnlineVenues
    // },
    // {
    //   path: '/settings/online/sharedbookings',
    //   name: 'settings-online-sharedbookings',
    //   component: OnlineSharedBookings
    // },
    // {
    //   path: '/settings/online/courses',
    //   name: 'settings-online-courses',
    //   component: OnlineCourses
    // },
    // {
    //   path: '/settings/online/rooms',
    //   name: 'settings-online-rooms',
    //   component: OnlineRooms
    // },
    // {
    //   path: '/settings/online/announcements',
    //   name: 'settings-online-announcements',
    //   component: OnlineAnnouncements
    // },
    // {
    //   path: '/settings/online/infoscreens',
    //   name: 'settings-online-infoscreens',
    //   component: OnlineInfoscreens
    // },
    // {
    //   path: '/settings/online/venueclusters',
    //   name: 'settings-online-venueclusters',
    //   component: OnlineVenueClusters
    // },
    // {
    //   path: '/settings/online/createvenuecluster',
    //   name: 'settings-online-createvenuecluster',
    //   component: OnlineCreateVenueCluster
    // },
    // {
    //   path: '/settings/venues/data',
    //   name: 'settings-venues-data',
    //   component: SettingsVenuesData
    // },
    // {
    //   path: '/settings/venues/properties',
    //   name: 'settings-venues-data',
    //   component: SettingsVenuesProperties
    // },
    // {
    //   path: '/settings/venues/images',
    //   name: 'settings-venues-data',
    //   component: SettingsVenuesImages
    // },
    // {
    //   path: '/settings/venues/prices',
    //   name: 'settings-venues-data',
    //   component: SettingsVenuesPrices
    // },
    // {
    //   path: '/settings/venues/subscription',
    //   name: 'settings-venues-subscription',
    //   component: SettingsVenuesSubscription
    // },
    // {
    //   path: '/settings/venues/timeframes',
    //   name: 'settings-venues-timeframes',
    //   component: SettingsVenuesTimeframes
    // },
    // {
    //   path: '/settings/venues/timeframe',
    //   name: 'settings-venues-timeframe',
    //   component: SettingsVenuesTimeframe
    // },
    // {
    //   path: '/settings/venues/settings',
    //   name: 'settings-venues-settings',
    //   component: SettingsVenuesSettings
    // },
    // {
    //   path: '/settings/members/members',
    //   name: 'settings-members-members',
    //   component: SettingsMembersList
    // },
    // {
    //   path: '/settings/members/types',
    //   name: 'settings-members-types',
    //   component: SettingsMembersTypes
    // },
    // {
    //   path: '/settings/members/newtype',
    //   name: 'settings-members-newtype',
    //   component: SettingsMembersNewtype
    // },
    // {
    //   path: '/settings/staff/staffmembers',
    //   name: 'settings-staff-staffmembers',
    //   component: Staffmembers
    // },
    // {
    //   path: '/settings/staff/staffmembersnew',
    //   name: 'settings-staff-staffmembersnew',
    //   component: StaffmemberNew
    // },
    // {
    //   path: '/settings/staff/staffmessage',
    //   name: 'settings-staff-staffmessage',
    //   component: Staffmessage
    // },
    // {
    //   path: '/settings/rooms/categories/list',
    //   name: 'settings-rooms-categories-list',
    //   component: RoomCategoriesList
    // },
    // {
    //   path: '/settings/rooms/categories/new',
    //   name: 'settings-rooms-categories-new',
    //   component: RoomCategoriesNew
    // },
    // {
    //   path: '/venues/venuebookings',
    //   name: 'venues-venuebookings-general',
    //   component: VenueBookings
    // },
    // {
    //   path: '/venues/venuebooking/details',
    //   name: 'venues-venuebooking-details',
    //   component: VenueBookingDetails
    // },
    // {
    //   path: '/venues/days/schedule/pdf',
    //   name: 'venues-days-schedule-pdf',
    //   component: VenuesDaysSchedulePDF
    // },
    // {
    //   path: '/venues/scheduler',
    //   name: 'venues-scheduler',
    //   component: VenuesScheduler
    // },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
